module.exports = __webpack_public_path__ + "create/static/media/avatar_Matheus.3669025f.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Institucional/avatar_Matheus.png
// module id = 477
// module chunks = 39